import CardStyling from '../CardStyling';
import moment from 'moment';
import {
  type CardLayoutModelConstructorType,
  type CardLayoutModelType,
} from '../types';
import { type CardStylingDataStructure } from 'javascripts/shared-types';
import { type CardStylingTypesEnum_value } from 'components/framework/models/generated/types';
import { currentFlavorSupportsTeams } from 'javascripts/util/currentFlavorSupportsTeams';

type AgingRecordType = Extract<
  CardLayoutModelType,
  { durationInTeamWorkflowStatus: any }
>;

export class AgingRecord extends CardStyling {
  static type: CardStylingTypesEnum_value = 'AgingRecord';
  static title: string = 'Time in status (sidebar)';

  static attributesForModel(
    _modelClass: CardLayoutModelConstructorType
  ): string[] {
    return ['durationInTeamWorkflowStatus'];
  }

  static subqueriesForModel(modelClass: CardLayoutModelConstructorType): {} {
    return { teamWorkflowStatus: ['internalMeaning'] };
  }

  static availableForModel(
    modelClass: CardLayoutModelConstructorType
  ): boolean {
    if (!currentFlavorSupportsTeams()) {
      return false;
    }

    return super.availableForModel(modelClass);
  }

  exampleCardStyling() {
    return { highlightColor: 'red' };
  }

  cardStyling(record: AgingRecordType): CardStylingDataStructure {
    if (!record.teamWorkflowStatus?.isInProgress) return {};

    let highlightColor: CardStylingDataStructure['highlightColor'];

    if (typeof record.durationInTeamWorkflowStatus === 'number') {
      const daysInStatus = moment
        .duration(record.durationInTeamWorkflowStatus, 'seconds')
        .asDays();

      if (daysInStatus > 8) {
        highlightColor = 'var(--aha-red-600)';
      } else if (daysInStatus > 5) {
        highlightColor = 'var(--aha-yellow-600)';
      } else if (daysInStatus > 2) {
        highlightColor = 'var(--aha-gray-500)';
      }
    }

    return { highlightColor };
  }
}
